import { ShiftManagementDeleteUnassignedShiftDocument } from 'generated/resources/graphql'

import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { trackDeleteUnassignedShiftSubmit } from 'modules/shift_management/lib/trackEvents'
import type { UnassignedShift } from 'modules/shift_management/lib/types'

import { useUnassignedShifts } from './useUnassignedShifts'

const trackSubmitEvent = (unassignedShift: UnassignedShift) => {
  const shiftType = unassignedShift.isDefault ? 'defaultShift' : 'customShift'
  const counter = Number(unassignedShift.counter)

  trackDeleteUnassignedShiftSubmit(unassignedShift, shiftType, counter, 'contextual_button')
}

const useDestroyUnassignedShift = (unassignedShift: UnassignedShift) => {
  const [, dispatchUnassignedShifts] = useUnassignedShifts()

  const [deleteUnassignedShift, { loading }] = useMutation(
    ShiftManagementDeleteUnassignedShiftDocument,
    {
      extractorFn: (data) => data.shiftManagementMutations.deleteShiftmanagementUnassignedShift,
    }
  )

  const onDestroy = async (closePortal: ClosePortalFn) => {
    trackSubmitEvent(unassignedShift)

    const result = await deleteUnassignedShift({
      variables: { id: unassignedShift.id },
      update: (cache, { data }) => {
        if (data?.shiftManagementMutations.deleteShiftmanagementUnassignedShift.unassignedShift) {
          cache.evict({
            id: cache.identify(
              data.shiftManagementMutations.deleteShiftmanagementUnassignedShift.unassignedShift
            ),
          })
        }
      },
    })

    const handled = handleResult(result, (_errors) => {})
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('shift_management.actions.delete_unassigned_shifts_success'),
      })

      dispatchUnassignedShifts({ type: 'DESTROY_UNASSIGNED_SHIFT', unassignedShift })

      closePortal()
    }
  }

  return {
    onDestroy,
    submitting: loading,
  }
}

export { useDestroyUnassignedShift }
